/* nx-reveal.js — 滚动进场
 *
 * 为什么有这个文件：首页的 nexanovo-home-* 几个 section 有 IntersectionObserver
 * 进场动画，而 About / Contact / All Brands 完全没有 —— 同一个站，一半有生命
 * 一半是死的。这里把首页那套原样搬过来，参数一个不改，让四个页面同一个节奏。
 *
 * 参数来源：nexanovo-home-car-hotspots.liquid 的 setupReveal()
 *   36px 上浮 · opacity .7s ease · transform .85s cubic-bezier(.16,.84,.28,1)
 *   错峰 90ms（退场 45ms）· rootMargin -8%/-12% · threshold .18
 *
 * 零依赖，不用 GSAP / framer-motion。
 *
 * 用法：
 *   <div data-nx-reveal>                     单个元素
 *   <div data-nx-reveal data-nx-group="zones">  同 group 的按顺序错峰
 */
(function () {
  if (window.__nxReveal) return;
  window.__nxReveal = 1;

  /* 第一件事：给 <html> 打标记。
     隐藏元素的 CSS 全部挂在 html.nx-reveal-ready 之下 —— 也就是说
     只有这个脚本真的跑起来了，才允许把内容藏起来。
     否则（脚本 404、被拦截、报错、老浏览器）内容照常显示，
     最坏情况是"没有动效"，而不是"整块内容看不见"。 */
  document.documentElement.classList.add('nx-reveal-ready');

  var REDUCE = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var nodes = [].slice.call(document.querySelectorAll('[data-nx-reveal]'))
      .filter(function (el) { return !el.__nxBound; });
    if (!nodes.length) return;
    nodes.forEach(function (el) { el.__nxBound = 1; });

    // 用户关了动效，或浏览器太老 —— 直接显示，不做任何动画
    if (REDUCE || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('nx-in'); });
      return;
    }

    // 按 group 分组编号；没写 group 的各自独立（不参与错峰）
    var groups = {};
    nodes.forEach(function (el, i) {
      var g = el.getAttribute('data-nx-group') || ('_solo_' + i);
      (groups[g] = groups[g] || []).push(el);
    });
    Object.keys(groups).forEach(function (g) {
      var list = groups[g];
      // 组员多的时候把步长减半 —— 14 个品牌芯片 × 90ms 是 1.26 秒，最后一个等太久
      var step = list.length > 8 ? 45 : 90;
      list.forEach(function (el, idx) {
        el.__nxIdx = idx; el.__nxLen = list.length; el.__nxStep = step;
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        var i = el.__nxIdx || 0, n = el.__nxLen || 1, step = el.__nxStep || 90;
        // 进场按顺序，退场倒序且更快 —— 和首页一致
        var delay = e.isIntersecting ? i * step : (n - i - 1) * (step / 2);
        el.style.transitionDelay = delay + 'ms';
        el.classList.toggle('nx-in', e.isIntersecting);
      });
    }, { rootMargin: '-8% 0px -12%', threshold: 0.18 });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // 在主题编辑器里增删 section 之后重新绑定（__nxBound 保证不会重复观察）
  document.addEventListener('shopify:section:load', init);
})();
